import { render, staticRenderFns } from "./EnrollmentOrderList.vue?vue&type=template&id=60c9eff1&"
import script from "./EnrollmentOrderList.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentOrderList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports